import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "checkmark-circle-small-outline-24", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { stroke: "#000", fill: "none", fillRule: "evenodd", strokeWidth: 1.5 },
        React.createElement("circle", { cx: 12, cy: 12, r: 7.25 }),
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M9.5 12.5l1.5 2 3.5-5" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
